module.exports = __webpack_public_path__ + "img/1548527006.8bfb2bc8.jpg";